import { render, staticRenderFns } from "./events_page_layout.vue?vue&type=template&id=eae42636&scoped=true&"
import script from "./events_page_layout.vue?vue&type=script&lang=js&"
export * from "./events_page_layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae42636",
  null
  
)

export default component.exports